import { CivilDate } from 'tc39-proposal-temporal';

const convertISOStringToCivilDate = (isoString) => {
  const date = isoString.split('-');
  return new CivilDate(date[0], date[1], date[2]);
};

export {
  convertISOStringToCivilDate,
};
